(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const videos = new Set();
  const visible = new WeakMap();
  const automatic = new WeakMap();
  const canPlay = (video) => automatic.get(video) && !motion.matches && !document.hidden;
  const resume = (video) => { if (!canPlay(video)) return; video.muted = true; const promise = video.play(); if (promise && promise.catch) promise.catch(() => {}); };
  const watcher = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { const video = entry.target; const inView = entry.isIntersecting && entry.intersectionRatio >= 0.12; visible.set(video,inView); if (!inView) video.pause(); else resume(video); });
  }, { threshold: [0,0.12] }) : null;
  const register = (scope) => {
    const brandPage = document.querySelector('.ih-original-brand-page');
    if (brandPage && !brandPage.dataset.ihHeaderMeasured) {
      brandPage.dataset.ihHeaderMeasured = 'true';
      const header = brandPage.querySelector('.ih-complete-nav');
      const measure = () => brandPage.style.setProperty('--ih-ownheader-height', `${Math.ceil(header?.getBoundingClientRect().height || 0)}px`);
      measure();
      if ('ResizeObserver' in window) { const observer = new ResizeObserver(measure); if (header) observer.observe(header); }
      else window.addEventListener('resize', measure, { passive: true });
      if (document.fonts?.ready) document.fonts.ready.then(measure);
    }
    const home = document.querySelector('.ih-complete-home');
    if (home && !home.dataset.ihShellMeasured) {
      home.dataset.ihShellMeasured = 'true';
      const header = home.querySelector('.ih-complete-nav');
      const offer = home.querySelector('.ih-complete-offer');
      const measure = () => home.style.setProperty('--ih-shell-height', `${Math.ceil((header?.getBoundingClientRect().height || 0) + (offer?.getBoundingClientRect().height || 0))}px`);
      measure();
      if ('ResizeObserver' in window) { const observer = new ResizeObserver(measure); if (header) observer.observe(header); if (offer) observer.observe(offer); }
      else window.addEventListener('resize', measure, { passive: true });
      if (document.fonts?.ready) document.fonts.ready.then(measure);
    }
    scope.querySelectorAll('.ih-native-muse .faq-section-title').forEach((heading) => {
      if (heading.dataset.ihFaqKeyboard) return;
      heading.dataset.ihFaqKeyboard = 'true';
      const items = heading.nextElementSibling;
      if (!items?.classList.contains('faq-items')) return;
      heading.setAttribute('role', 'button');
      heading.tabIndex = 0;
      heading.setAttribute('aria-expanded', String(items.classList.contains('is-open')));
      const sync = () => {
        const expanded = !items.hidden;
        items.classList.toggle('is-open', expanded);
        heading.classList.toggle('open', expanded);
        heading.setAttribute('aria-expanded', String(expanded));
      };
      heading.addEventListener('click', (event) => {
        event.stopPropagation();
        items.hidden = !items.hidden;
        sync();
      });
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); heading.click(); }
      });
      // Source categories start closed; clicking keeps their original class-based presentation.
      items.hidden = !items.classList.contains('is-open');
    });
    scope.querySelectorAll('.ih-complete video').forEach((video) => {
      if (observed.has(video)) return;
      observed.add(video); videos.add(video);
      automatic.set(video, video.hasAttribute('autoplay') || video.dataset.ihVideoAutoplay === 'true');
      if (automatic.get(video)) { video.muted = true; video.autoplay = false; video.removeAttribute('autoplay'); if (motion.matches) video.pause(); }
      video.playsInline = true;
      if (watcher) watcher.observe(video);
    });
    scope.querySelectorAll('.ih-complete-nav__menu').forEach((menu) => menu.addEventListener('toggle', () => { if (menu.open) scope.querySelectorAll('.ih-complete-nav__menu').forEach((other) => { if (other !== menu) other.open = false; }); }));
  };
  const preferenceChange = () => videos.forEach((video) => { if (!video.isConnected) { if (watcher) watcher.unobserve(video); videos.delete(video); } else if (motion.matches && automatic.get(video)) video.pause(); else if (visible.get(video)) resume(video); });
  if (motion.addEventListener) motion.addEventListener('change',preferenceChange); else motion.addListener(preferenceChange);
  document.addEventListener('visibilitychange',() => videos.forEach((video) => { if (document.hidden) video.pause(); else if (visible.get(video)) resume(video); }));
  document.addEventListener('click',(event) => { if (!event.target.closest('.ih-complete-nav__menu')) document.querySelectorAll('.ih-complete-nav__menu').forEach((menu) => { menu.open = false; }); });
  document.addEventListener('keydown',(event) => { if (event.key === 'Escape') document.querySelectorAll('.ih-complete-nav__menu').forEach((menu) => { menu.open = false; }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => register(document),{once:true}); else register(document);
  document.addEventListener('shopify:section:load',(event) => register(event.target));
})();

(() => {
  const openPreview = (anchor) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'ih-media-preview';
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = 'Close'; close.setAttribute('aria-label', 'Close media preview');
    let media;
    if (anchor.dataset.ihEmbedVideo) {
      media = document.createElement('iframe');
      media.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(anchor.dataset.ihEmbedVideo);
      media.title = 'Original manufacturer video';
      media.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation');
      media.allow = 'encrypted-media; picture-in-picture'; media.allowFullscreen = true;
    } else if (anchor.dataset.ihAudioPreview) {
      media = document.createElement('audio'); media.src = anchor.dataset.ihAudioPreview; media.controls = true;
    } else {
      media = document.createElement('img'); media.src = anchor.dataset.ihImagePreview; media.alt = 'Original manufacturer product image';
    }
    dialog.append(close, media); document.body.append(dialog);
    const previous = document.activeElement;
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { if (media.pause) media.pause(); dialog.remove(); previous?.focus(); });
    dialog.showModal(); close.focus();
  };
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[data-ih-embed-video],a[data-ih-audio-preview],a[data-ih-image-preview]');
    if (!anchor || anchor.hasAttribute('data-media-target')) return;
    event.preventDefault(); openPreview(anchor);
  });
})();
